/**
 * THIS FILE IS AUTOGENERATED, DO NOT EDIT IT!
 *
 * See codegen config in .graphqlrc.yml for details
 */

/** Internal type. DO NOT USE DIRECTLY. */
type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
/** Internal type. DO NOT USE DIRECTLY. */
export type Incremental<T> =
  | T
  | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
import { gql } from 'urql';
import * as Urql from 'urql';

import type * as Types from '@sg/graphql-schema';
export type Omit<T, K extends keyof T> = Pick<T, Exclude<keyof T, K>>;
export type LocationByAddressIdInput = {
  /** id for an address present in the current session. */
  readonly addressId: string | number;
  readonly useCartRestaurant?: boolean | null | undefined;
};

export type LocationByAddressV2Input = {
  readonly address1: string;
  readonly address2?: string | null | undefined;
  readonly city: string;
  readonly lat: number;
  readonly lon: number;
  readonly state: string;
  readonly zipcode: number;
};

export type LocationStatus = 'CLOSED' | 'INVALID' | 'OPEN';

export type RestaurantDetailsFragment = {
  readonly __typename: 'Restaurant';
  readonly id: string;
  readonly name: string;
  readonly slug: string;
  readonly phone: string;
  readonly flexMessage: string | null;
};

export type DeliveryLocationByAddressIdQueryVariables = Exact<{
  input: Types.LocationByAddressIdInput;
}>;

export type DeliveryLocationByAddressIdQuery = {
  readonly locationByAddressId:
    | { readonly __typename: 'InvalidInput' }
    | {
        readonly __typename: 'Location';
        readonly deliveryFee: number;
        readonly status: Types.LocationStatus;
        readonly restaurant: {
          readonly __typename: 'Restaurant';
          readonly showDeliveryPriceDifferenciationDisclosure: boolean;
          readonly id: string;
          readonly name: string;
          readonly slug: string;
          readonly phone: string;
          readonly flexMessage: string | null;
        };
        readonly estimateRange: { readonly start: number; readonly end: number };
        readonly vendor: { readonly name: string; readonly restaurantId: string };
      }
    | { readonly __typename: 'NoValidRestaurants' }
    | { readonly __typename: 'ValidationError' };
};

export type DeliveryLocationByAddressV2QueryVariables = Exact<{
  input: Types.LocationByAddressV2Input;
}>;

export type DeliveryLocationByAddressV2Query = {
  readonly locationByAddressV2:
    | { readonly __typename: 'InvalidInput' }
    | {
        readonly __typename: 'Location';
        readonly deliveryFee: number;
        readonly status: Types.LocationStatus;
        readonly restaurant: {
          readonly __typename: 'Restaurant';
          readonly showDeliveryPriceDifferenciationDisclosure: boolean;
          readonly id: string;
          readonly name: string;
          readonly slug: string;
          readonly phone: string;
          readonly flexMessage: string | null;
        };
        readonly estimateRange: { readonly start: number; readonly end: number };
        readonly vendor: { readonly name: string; readonly restaurantId: string };
      }
    | { readonly __typename: 'NoValidRestaurants' }
    | { readonly __typename: 'ValidationError' };
};

export const RestaurantDetailsFragmentDoc = gql`
  fragment RestaurantDetails on Restaurant {
    id
    __typename
    name
    slug
    phone
    flexMessage
  }
`;
export const DeliveryLocationByAddressIdDocument = gql`
  query DeliveryLocationByAddressId($input: LocationByAddressIdInput!) {
    locationByAddressId(input: $input) {
      __typename
      ... on Location {
        deliveryFee
        restaurant {
          ...RestaurantDetails
          showDeliveryPriceDifferenciationDisclosure
        }
        estimateRange {
          start
          end
        }
        vendor {
          name
          restaurantId
        }
        status
      }
    }
  }
  ${RestaurantDetailsFragmentDoc}
`;

export function useDeliveryLocationByAddressIdQuery(
  options: Omit<Urql.UseQueryArgs<DeliveryLocationByAddressIdQueryVariables>, 'query'>,
) {
  return Urql.useQuery<DeliveryLocationByAddressIdQuery, DeliveryLocationByAddressIdQueryVariables>(
    { query: DeliveryLocationByAddressIdDocument, ...options },
  );
}
export const DeliveryLocationByAddressV2Document = gql`
  query DeliveryLocationByAddressV2($input: LocationByAddressV2Input!) {
    locationByAddressV2(input: $input) {
      __typename
      ... on Location {
        deliveryFee
        restaurant {
          ...RestaurantDetails
          showDeliveryPriceDifferenciationDisclosure
        }
        estimateRange {
          start
          end
        }
        vendor {
          name
          restaurantId
        }
        status
      }
    }
  }
  ${RestaurantDetailsFragmentDoc}
`;

export function useDeliveryLocationByAddressV2Query(
  options: Omit<Urql.UseQueryArgs<DeliveryLocationByAddressV2QueryVariables>, 'query'>,
) {
  return Urql.useQuery<DeliveryLocationByAddressV2Query, DeliveryLocationByAddressV2QueryVariables>(
    { query: DeliveryLocationByAddressV2Document, ...options },
  );
}
